import React, { useState } from "react";
import "./YearSelector.scss";

// const CALENDAR_YEARS = [2024, 2025, 2026, 2027, 2028];
const YEARS_BEFORE = 5;
const YEARS_AFTER = 1;

export const CALENDAR_YEARS = Array.from(
  { length: YEARS_BEFORE + YEARS_AFTER + 1 },
  (_, i) => new Date().getFullYear() - YEARS_BEFORE + i
);

const YEAR_OPTIONS = CALENDAR_YEARS.map((year) => ({
  title: String(year),
  id: year,
}));

const YearSelector = ({ options = YEAR_OPTIONS, selectedYear, isLoading = false, textColor, onYearSelect }) => {
  const handleChange = (event) => {
    onYearSelect(Number(event.target.value));
  };

  return (
    <div className="year-row">
      <div className="year-button">
        <span className="year-text" style={{ color: textColor }}>
          {selectedYear?.title}
        </span>

        <select
          className="year-select"
          value={selectedYear?.id ?? ""}
          onChange={handleChange}
          aria-label={`Year ${selectedYear?.title}, tap to change`}
        >
          {options.map((item) => (
            <option key={item.id} value={item.id}>
              {item.title}
            </option>
          ))}
        </select>
      </div>

      {isLoading && <span className="loading-spinner" style={{ borderTopColor: textColor }} />}
    </div>
  );
};

export default YearSelector;
